export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  {
    slug: "movie",
    name: "电影",
    icon: "ri-movie-2-line",
    description: "国内外最新最热电影，高清免费在线观看",
  },
  {
    slug: "tv",
    name: "电视剧",
    icon: "ri-tv-2-line",
    description: "热播电视剧每日更新，追剧必备平台",
  },
  {
    slug: "anime",
    name: "动漫",
    icon: "ri-rocket-line",
    description: "热血、玄幻、治愈，各类动漫应有尽有",
  },
  {
    slug: "variety",
    name: "综艺",
    icon: "ri-emotion-laugh-line",
    description: "搞笑、音乐、竞技综艺，欢乐不间断",
  },
  {
    slug: "documentary",
    name: "纪录片",
    icon: "ri-camera-lens-line",
    description: "自然、人文、美食纪录片，开拓视野",
  },
];